// v1.8.27 — parse angka locale-aware: dukung format Indonesia ("1.234,56", "52,2")
// dan English ("1,234.56", "52.2"). Titik tunggal dengan 1-2 digit di belakang = desimal.
export const parseLocaleNum = (v) => {
    if (v === null || v === undefined || v === "") return 0;
    if (typeof v === "number") return isNaN(v) ? 0 : v;
    const s = String(v).trim().replace(/\s/g, "");
    if (!s) return 0;
    const hasComma = s.includes(",");
    const hasDot = s.includes(".");
    let n;
    if (hasComma && hasDot) {
        n = s.lastIndexOf(",") > s.lastIndexOf(".")
            ? parseFloat(s.replace(/\./g, "").replace(",", "."))
            : parseFloat(s.replace(/,/g, ""));
    } else if (hasComma) {
        const parts = s.split(",");
        n = parts.length === 2 && /^\d{3}$/.test(parts[1]) && !/^0+$/.test(parts[0])
            ? parseFloat(s.replace(/,/g, ""))
            : parseFloat(parts.length === 2 ? s.replace(",", ".") : s.replace(/,/g, ""));
    } else if (hasDot) {
        const parts = s.split(".");
        n = parts.length === 2 && parts[1].length >= 1 && parts[1].length <= 2
            ? parseFloat(s)
            : parseFloat(s.replace(/\./g, ""));
    } else {
        n = parseFloat(s);
    }
    return isNaN(n) ? 0 : n;
};

// Format detail error dari backend FastAPI (string / Pydantic 422 array / message plain)
export const errMsg = (e, fallback = "Gagal menyimpan") => {
    const d = e?.response?.data;
    if (typeof d?.detail === "string") return d.detail;
    if (Array.isArray(d?.detail)) {
        return d.detail
            .map((x) => `${(x.loc || []).slice(-1)[0] || "field"}: ${x.msg}`)
            .join("; ");
    }
    if (typeof d?.message === "string") return d.message;
    return e?.message || fallback;
};
